import { useEffect } from 'react';
import { ROUTES } from '../routes';
import { clearPersistedToken, persistParams, persistRoute, persistToken } from './session-storage';

function usePersistedNavigationState(route, params) {
  useEffect(() => {
    persistRoute(route);
  }, [route]);

  useEffect(() => {
    persistParams(params);
  }, [params]);
}

function useAuthTokenSync(authToken, route, setRoute, syncFromApi) {
  useEffect(() => {
    if (authToken) {
      persistToken(authToken);
      syncFromApi(authToken);
      return;
    }

    clearPersistedToken();
    if (route !== ROUTES.LOGIN) setRoute(ROUTES.LOGIN);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authToken]);
}

export { usePersistedNavigationState, useAuthTokenSync };
